/**
 * ChartCreator's price and valuation time series silently fall back to daily
 * data for "Q" and "A"; it only honours the calendar spellings there.
 */
const TIME_SERIES_FREQUENCY_ALIASES: Readonly<Record<string, string>> = { Q: "CQ", A: "CY" };

/** The frequency ChartCreator needs for `chartType`; other values pass through. */
export function chartCreatorFrequency(chartType: string, frequency: string): string {
  return /^(?:P|VAL)_/i.test(chartType)
    ? TIME_SERIES_FREQUENCY_ALIASES[frequency.toUpperCase()] ?? frequency
    : frequency;
}
